<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup>
// import { useRoute } from 'vue-router'

// const router = useRouter()
const route = useRoute()
const config = useAppConfig()

let noTrailingSlashPath = computed(() => {
    //    try {
    //        let path = route.path
    //        // console.log('path', path)
    //    } catch (error) {
    //        // console.log('error', error)
    //        throw new Error('route.path error [app.vue]')
    //    }

    return route.path.endsWith('/') ? route.path.slice(0, -1) : route.path
})

const canonicalUrl = computed(() => {
    return `${config.WWW_HOST}${noTrailingSlashPath.value}`
})

// router.beforeEach((to, from, next) => {
//     console.log('kk, beforeEach', to, from)

//     // find ?next= in url
//     const nextParam = to.query.theme
//     if (nextParam) {
//         console.log('✅ kk, nextParam', nextParam)
//         // remove ?next= from url
//         // to.query.next = undefined
//         // redirect to next
//         // router.push(nextParam)
//     }
//     next()
// })

useSeoMeta({
    title: config.rootTitle,
    description: config.rootDescription,
    ogTitle: config.rootTitle,
    ogDescription: config.rootDescription,
    ogImage: () => `${config.WWW_HOST}/misc/ogimages/ogimage_main.png`, // default site-wide og image
    ogType: 'website',
    ogSiteName: 'Foldwrap',
    ogLocale: 'en_US',
    twitterCard: 'summary_large_image',
    twitterTitle: config.rootTitle,
    twitterImage: () => `${config.WWW_HOST}/misc/ogimages/ogimage_main.png`, // default site-wide twitter image
    robots: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
})

useHead({
    link: [
        {
            // Adding canonical url dynamically to all pages
            // https://stackoverflow.com/questions/73866334/how-to-add-canonical-url-in-nuxt3
            rel: 'canonical',
            href: `${config.WWW_HOST}${noTrailingSlashPath.value}`,
        },
        {
            rel: 'sitemap',
            type: 'application/xml',
            href: `${config.WWW_HOST}/sitemap.xml`,
        },
        {
            rel: 'dns-prefetch',
            href: '//foldwrap.com',
        },
        {
            rel: 'shortcut icon',
            type: 'image/x-icon',
            sizes: 'any',
            href: `${config.WWW_HOST}/favicon.ico`,
        },
        {
            rel: 'icon',
            type: 'image/png',
            sizes: '16x16',
            href: `${config.WWW_HOST}/misc/favicons/favicon-16x16.png`,
        },
        {
            rel: 'icon',
            type: 'image/png',
            sizes: '32x32',
            href: `${config.WWW_HOST}/misc/favicons/favicon-32x32.png`,
        },
        {
            rel: 'apple-touch-icon',
            sizes: '180x180',
            href: `${config.WWW_HOST}/misc/favicons/apple-touch-icon.png`,
        },
        {
            rel: 'icon',
            type: 'image/svg+xml',
            href: `${config.WWW_HOST}/misc/favicons/favicon.svg`,
        },
        {
            rel: 'mask-icon',
            type: 'image/svg+xml',
            color: '#111111',
            href: `${config.WWW_HOST}/misc/favicons/favicon.svg`,
        },
        {
            rel: 'manifest',
            href: `${config.WWW_HOST}/misc/favicons/site.webmanifest`,
        },
    ],

    meta: [
        {
            hid: 'og-url',
            property: 'og:url',
            content: `${config.WWW_HOST}${noTrailingSlashPath.value}`,
        },
        {
            // Only add the twitter:site tag for routes NOT starting with "/blog/"
            // because in blog this tag set individually in each .md file
            ...(!noTrailingSlashPath.value.startsWith('/blog') && {
                hid: 'twitter-site',
                name: 'twitter:site',
                content: '@ress',
            }),
        },
    ],
})

watch(
    () => route.path,
    () => {
        useHead({
            link: [
                {
                    rel: 'canonical',
                    href: canonicalUrl.value,
                },
            ],
            meta: [
                {
                    hid: 'og-url',
                    property: 'og:url',
                    content: canonicalUrl.value,
                },
            ],
        })
    }
)
</script>

<style lang="scss">
@use './assets/style/main.scss';
</style>
